/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class MaxRetentionRule {
  /**
  * Whether the rule is enabled
  */
  'enabled': boolean;
  /**
  * The maximum backup retention period in days
  */
  'maximumRetention': number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "enabled",
      "baseName": "enabled",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "maximumRetention",
      "baseName": "maximumRetention",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return MaxRetentionRule.attributeTypeMap;
  }

  public constructor() {
  }
}

